import { CompanyContactId, Dtos, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountCompaniesQueryKey, accountQueryKey } from "../account.keys";

export const useAdminUpsertCompanyContact = (
	accountId: SuretyAccountId,
	companyContactId?: CompanyContactId,
) => {
	const queryClient = useQueryClient();
	const { post, put } = useRequest();

	const mutation = useMutation({
		mutationFn: async (data: Dtos.Admin.CompanyContact.Create.Request) => {
			if (companyContactId) {
				await put(
					`/v2/admin/surety/accounts/${accountId}/companies/${companyContactId}`,
					data,
					"none",
				);
			} else {
				await post(`/v2/admin/surety/accounts/${accountId}/companies`, data, "none");
			}
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountCompaniesQueryKey(accountId) }),
			]);
		},
	});

	return {
		upsertCompanyContact: mutation.mutate,
		upsertCompanyContactError: mutation.error,
		upsertCompanyContactIsLoading: mutation.isPending,
		upsertCompanyContactSuccess: mutation.isSuccess,
	};
};
